import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import NotificationBroadcastContent from "../../components/Masters/NotificationBroadcast/NotificationBroadcastContent";
import {
  getVesselMasterList,
  getSendNotificationMasterList,
} from "../../redux/actions/mastersAction";

const NotificationBroadcast = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSendNotificationMasterList());

    dispatch(
      getVesselMasterList({
        active: "",
        searchByFirstName: "",
        limit: "",
        offset: "",
      })
    );
  }, []);
  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <NotificationBroadcastContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default NotificationBroadcast;
